import { type Client, graphql, prefetch } from "@opensea/graphql"
import { CollectionTraitItemsCardFragment } from "../CollectionTraitItemsGrid"
import { CollectionTraitItemsTableRowFragment } from "../CollectionTraitItemsTable"
import { PAGE_SIZE } from "../constants"

export const CollectionTraitItemsListQuery = graphql(
  `
    query CollectionTraitItemsListQuery(
      $cursor: String
      $sort: CollectionAttributeSort!
      $collectionSlug: String!
      $limit: Int!
      $filter: CollectionAttributeFilter
    ) {
      collectionAttributesBySlug(
        slug: $collectionSlug
        cursor: $cursor
        sort: $sort
        limit: $limit
        filter: $filter
      ) {
        items {
          traitType
          traitValue
          ...CollectionTraitItemsCard
          ...CollectionTraitItemsTableRow
        }
        nextPageCursor
      }
    }
  `,
  [CollectionTraitItemsCardFragment, CollectionTraitItemsTableRowFragment],
)

export const prefetchCollectionTraitItemsListQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionTraitItemsListQuery, {
    collectionSlug,
    filter: { attributes: [] },
    limit: PAGE_SIZE,
    sort: { by: "FLOOR_PRICE", direction: "DESC" },
  })
}
